export const environment = {
	production: true,
	SHARE_URL: 'https://infoday.io',
	COOKIE_SECURE: true,
	COOKIE_DOMAIN: 'https://infoday.io',
	LinkedInClientId: '78hfudv1z68ye9',
	LinkedInClientSecret: 'KVR516NeKYKrRklG',
	LinkedInRedirectUrlRegister: 'https://infoday.io/register',
	LinkedInRedirectUrlLogin: 'https://infoday.io/login',
	API_URL: 'https://api.espresso-tutorials.com/',
	API_URL_V2: 'https://api.espresso-tutorials.com/api/v2/',
	TRACING: 0,
	VERSION: require('../../package.json').version,
	pusher: '01hzppvg67ps15yvz2arfbtte0',
	pusherCluster: 'eu',
	pusherAppId: '01hzpptd8pbb30gn9wqwhfg1sj',
	enabledTransports: ['wss'],
	forceTLS: true,
};
